/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthVerifyEmailRouteImport } from './routes/auth/verify-email'
import { Route as AuthResetLinkSentRouteImport } from './routes/auth/reset-link-sent'
import { Route as AuthPendingApprovalRouteImport } from './routes/auth/pending-approval'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AuthenticatedTemplateRequestsRouteImport } from './routes/_authenticated/template-requests'
import { Route as AuthenticatedSuperAdminUsersRouteImport } from './routes/_authenticated/super-admin-users'
import { Route as AuthenticatedSuperAdminTemplateRequestsRouteImport } from './routes/_authenticated/super-admin-template-requests'
import { Route as AuthenticatedSuperAdminSubscriptionsRouteImport } from './routes/_authenticated/super-admin-subscriptions'
import { Route as AuthenticatedSuperAdminPlansRouteImport } from './routes/_authenticated/super-admin-plans'
import { Route as AuthenticatedSuperAdminPaymentsRouteImport } from './routes/_authenticated/super-admin-payments'
import { Route as AuthenticatedSuperAdminLogsRouteImport } from './routes/_authenticated/super-admin-logs'
import { Route as AuthenticatedSuperAdminListingRequestsRouteImport } from './routes/_authenticated/super-admin-listing-requests'
import { Route as AuthenticatedSuperAdminLawyerProfilesRouteImport } from './routes/_authenticated/super-admin-lawyer-profiles'
import { Route as AuthenticatedSuperAdminFeedbackRouteImport } from './routes/_authenticated/super-admin-feedback'
import { Route as AuthenticatedSuperAdminDocumentTemplatesRouteImport } from './routes/_authenticated/super-admin-document-templates'
import { Route as AuthenticatedSuperAdminDocumentTemplateCreateRouteImport } from './routes/_authenticated/super-admin-document-template-create'
import { Route as AuthenticatedSuperAdminDashboardRouteImport } from './routes/_authenticated/super-admin-dashboard'
import { Route as AuthenticatedSuperAdminCrmRouteImport } from './routes/_authenticated/super-admin-crm'
import { Route as AuthenticatedSuperAdminCreditManagementRouteImport } from './routes/_authenticated/super-admin-credit-management'
import { Route as AuthenticatedSuperAdminChatbotConfigRouteImport } from './routes/_authenticated/super-admin-chatbot-config'
import { Route as AuthenticatedSuperAdminCabinetsRouteImport } from './routes/_authenticated/super-admin-cabinets'
import { Route as AuthenticatedSuperAdminBlogPreviewRouteImport } from './routes/_authenticated/super-admin-blog-preview'
import { Route as AuthenticatedSuperAdminBlogEditRouteImport } from './routes/_authenticated/super-admin-blog-edit'
import { Route as AuthenticatedSuperAdminBlogDomainsRouteImport } from './routes/_authenticated/super-admin-blog-domains'
import { Route as AuthenticatedSuperAdminBlogCreateRouteImport } from './routes/_authenticated/super-admin-blog-create'
import { Route as AuthenticatedSuperAdminBlogRouteImport } from './routes/_authenticated/super-admin-blog'
import { Route as AuthenticatedSuperAdminAuditLogsRouteImport } from './routes/_authenticated/super-admin-audit-logs'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedLawyerProfileRouteImport } from './routes/_authenticated/lawyer-profile'
import { Route as AuthenticatedHonorairesRouteImport } from './routes/_authenticated/honoraires'
import { Route as AuthenticatedGuidesRouteImport } from './routes/_authenticated/guides'
import { Route as AuthenticatedDocumentsRouteImport } from './routes/_authenticated/documents'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedChatbotRouteImport } from './routes/_authenticated/chatbot'
import { Route as AuthenticatedCabinetSubscriptionsRouteImport } from './routes/_authenticated/cabinet-subscriptions'
import { Route as AuthenticatedCabinetSettingsRouteImport } from './routes/_authenticated/cabinet-settings'
import { Route as AuthenticatedCabinetRolesRouteImport } from './routes/_authenticated/cabinet-roles'
import { Route as AuthenticatedCabinetPlansRouteImport } from './routes/_authenticated/cabinet-plans'
import { Route as AuthenticatedCabinetDocumentTemplatesRouteImport } from './routes/_authenticated/cabinet-document-templates'
import { Route as AuthenticatedCabinetDocumentTemplateCreateRouteImport } from './routes/_authenticated/cabinet-document-template-create'
import { Route as AuthenticatedCabinetBillingRouteImport } from './routes/_authenticated/cabinet-billing'
import { Route as AuthSignupRouteRouteImport } from './routes/auth/signup.route'
import { Route as AuthLoginRouteRouteImport } from './routes/auth/login.route'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedSuperAdminLawyerProfilesIndexRouteImport } from './routes/_authenticated/super-admin-lawyer-profiles.index'
import { Route as AuthenticatedInvoicesIndexRouteImport } from './routes/_authenticated/invoices/index'
import { Route as AuthenticatedExternalLawyersIndexRouteImport } from './routes/_authenticated/external-lawyers/index'
import { Route as AuthenticatedExpensesIndexRouteImport } from './routes/_authenticated/expenses/index'
import { Route as AuthenticatedClientsIndexRouteImport } from './routes/_authenticated/clients/index'
import { Route as AuthenticatedCasesIndexRouteImport } from './routes/_authenticated/cases/index'
import { Route as AuthenticatedAffectationIndexRouteImport } from './routes/_authenticated/affectation/index'
import { Route as AuthenticatedAdversariesIndexRouteImport } from './routes/_authenticated/adversaries/index'
import { Route as AuthenticatedSuperAdminLawyerProfilesIdRouteImport } from './routes/_authenticated/super-admin-lawyer-profiles.$id'
import { Route as AuthenticatedSuperAdminDocumentTemplateSlugRouteImport } from './routes/_authenticated/super-admin-document-template.$slug'
import { Route as AuthenticatedCasesReportRouteImport } from './routes/_authenticated/cases/report'
import { Route as AuthenticatedCabinetDocumentTemplateSlugRouteImport } from './routes/_authenticated/cabinet-document-template.$slug'
import { Route as AuthenticatedCasesIdIndexRouteImport } from './routes/_authenticated/cases/$id/index'
import { Route as AuthVerifyEmailConfirmUidb64TokenRouteImport } from './routes/auth/verify-email-confirm.$uidb64.$token'
import { Route as AuthResetPasswordConfirmUidb64TokenRouteImport } from './routes/auth/reset-password-confirm.$uidb64.$token'

const AuthenticatedUsersIdIndexLazyRouteImport = createFileRoute(
  '/_authenticated/users/$id/',
)()
const AuthenticatedInvoicesIdIndexLazyRouteImport = createFileRoute(
  '/_authenticated/invoices/$id/',
)()
const AuthenticatedClientsIdIndexLazyRouteImport = createFileRoute(
  '/_authenticated/clients/$id/',
)()
const AuthenticatedAdversariesIdIndexLazyRouteImport = createFileRoute(
  '/_authenticated/adversaries/$id/',
)()

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/auth/verify-email',
  path: '/auth/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetLinkSentRoute = AuthResetLinkSentRouteImport.update({
  id: '/auth/reset-link-sent',
  path: '/auth/reset-link-sent',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthPendingApprovalRoute = AuthPendingApprovalRouteImport.update({
  id: '/auth/pending-approval',
  path: '/auth/pending-approval',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/auth/forgot-password',
  path: '/auth/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedTemplateRequestsRoute =
  AuthenticatedTemplateRequestsRouteImport.update({
    id: '/template-requests',
    path: '/template-requests',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminUsersRoute =
  AuthenticatedSuperAdminUsersRouteImport.update({
    id: '/super-admin-users',
    path: '/super-admin-users',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminTemplateRequestsRoute =
  AuthenticatedSuperAdminTemplateRequestsRouteImport.update({
    id: '/super-admin-template-requests',
    path: '/super-admin-template-requests',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminSubscriptionsRoute =
  AuthenticatedSuperAdminSubscriptionsRouteImport.update({
    id: '/super-admin-subscriptions',
    path: '/super-admin-subscriptions',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminPlansRoute =
  AuthenticatedSuperAdminPlansRouteImport.update({
    id: '/super-admin-plans',
    path: '/super-admin-plans',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminPaymentsRoute =
  AuthenticatedSuperAdminPaymentsRouteImport.update({
    id: '/super-admin-payments',
    path: '/super-admin-payments',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminLogsRoute =
  AuthenticatedSuperAdminLogsRouteImport.update({
    id: '/super-admin-logs',
    path: '/super-admin-logs',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminListingRequestsRoute =
  AuthenticatedSuperAdminListingRequestsRouteImport.update({
    id: '/super-admin-listing-requests',
    path: '/super-admin-listing-requests',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminLawyerProfilesRoute =
  AuthenticatedSuperAdminLawyerProfilesRouteImport.update({
    id: '/super-admin-lawyer-profiles',
    path: '/super-admin-lawyer-profiles',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminFeedbackRoute =
  AuthenticatedSuperAdminFeedbackRouteImport.update({
    id: '/super-admin-feedback',
    path: '/super-admin-feedback',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminDocumentTemplatesRoute =
  AuthenticatedSuperAdminDocumentTemplatesRouteImport.update({
    id: '/super-admin-document-templates',
    path: '/super-admin-document-templates',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminDocumentTemplateCreateRoute =
  AuthenticatedSuperAdminDocumentTemplateCreateRouteImport.update({
    id: '/super-admin-document-template-create',
    path: '/super-admin-document-template-create',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminDashboardRoute =
  AuthenticatedSuperAdminDashboardRouteImport.update({
    id: '/super-admin-dashboard',
    path: '/super-admin-dashboard',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminCrmRoute =
  AuthenticatedSuperAdminCrmRouteImport.update({
    id: '/super-admin-crm',
    path: '/super-admin-crm',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminCreditManagementRoute =
  AuthenticatedSuperAdminCreditManagementRouteImport.update({
    id: '/super-admin-credit-management',
    path: '/super-admin-credit-management',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminChatbotConfigRoute =
  AuthenticatedSuperAdminChatbotConfigRouteImport.update({
    id: '/super-admin-chatbot-config',
    path: '/super-admin-chatbot-config',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminCabinetsRoute =
  AuthenticatedSuperAdminCabinetsRouteImport.update({
    id: '/super-admin-cabinets',
    path: '/super-admin-cabinets',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminBlogPreviewRoute =
  AuthenticatedSuperAdminBlogPreviewRouteImport.update({
    id: '/super-admin-blog-preview',
    path: '/super-admin-blog-preview',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminBlogEditRoute =
  AuthenticatedSuperAdminBlogEditRouteImport.update({
    id: '/super-admin-blog-edit',
    path: '/super-admin-blog-edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminBlogDomainsRoute =
  AuthenticatedSuperAdminBlogDomainsRouteImport.update({
    id: '/super-admin-blog-domains',
    path: '/super-admin-blog-domains',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminBlogCreateRoute =
  AuthenticatedSuperAdminBlogCreateRouteImport.update({
    id: '/super-admin-blog-create',
    path: '/super-admin-blog-create',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminBlogRoute =
  AuthenticatedSuperAdminBlogRouteImport.update({
    id: '/super-admin-blog',
    path: '/super-admin-blog',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminAuditLogsRoute =
  AuthenticatedSuperAdminAuditLogsRouteImport.update({
    id: '/super-admin-audit-logs',
    path: '/super-admin-audit-logs',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedLawyerProfileRoute =
  AuthenticatedLawyerProfileRouteImport.update({
    id: '/lawyer-profile',
    path: '/lawyer-profile',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHonorairesRoute = AuthenticatedHonorairesRouteImport.update({
  id: '/honoraires',
  path: '/honoraires',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedGuidesRoute = AuthenticatedGuidesRouteImport.update({
  id: '/guides',
  path: '/guides',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDocumentsRoute = AuthenticatedDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedChatbotRoute = AuthenticatedChatbotRouteImport.update({
  id: '/chatbot',
  path: '/chatbot',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCabinetSubscriptionsRoute =
  AuthenticatedCabinetSubscriptionsRouteImport.update({
    id: '/cabinet-subscriptions',
    path: '/cabinet-subscriptions',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCabinetSettingsRoute =
  AuthenticatedCabinetSettingsRouteImport.update({
    id: '/cabinet-settings',
    path: '/cabinet-settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCabinetRolesRoute =
  AuthenticatedCabinetRolesRouteImport.update({
    id: '/cabinet-roles',
    path: '/cabinet-roles',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCabinetPlansRoute =
  AuthenticatedCabinetPlansRouteImport.update({
    id: '/cabinet-plans',
    path: '/cabinet-plans',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCabinetDocumentTemplatesRoute =
  AuthenticatedCabinetDocumentTemplatesRouteImport.update({
    id: '/cabinet-document-templates',
    path: '/cabinet-document-templates',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCabinetDocumentTemplateCreateRoute =
  AuthenticatedCabinetDocumentTemplateCreateRouteImport.update({
    id: '/cabinet-document-template-create',
    path: '/cabinet-document-template-create',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCabinetBillingRoute =
  AuthenticatedCabinetBillingRouteImport.update({
    id: '/cabinet-billing',
    path: '/cabinet-billing',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthSignupRouteRoute = AuthSignupRouteRouteImport.update({
  id: '/auth/signup',
  path: '/auth/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRouteRoute = AuthLoginRouteRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSuperAdminLawyerProfilesIndexRoute =
  AuthenticatedSuperAdminLawyerProfilesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSuperAdminLawyerProfilesRoute,
  } as any)
const AuthenticatedInvoicesIndexRoute =
  AuthenticatedInvoicesIndexRouteImport.update({
    id: '/invoices/',
    path: '/invoices/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedExternalLawyersIndexRoute =
  AuthenticatedExternalLawyersIndexRouteImport.update({
    id: '/external-lawyers/',
    path: '/external-lawyers/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedExpensesIndexRoute =
  AuthenticatedExpensesIndexRouteImport.update({
    id: '/expenses/',
    path: '/expenses/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedClientsIndexRoute =
  AuthenticatedClientsIndexRouteImport.update({
    id: '/clients/',
    path: '/clients/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCasesIndexRoute = AuthenticatedCasesIndexRouteImport.update({
  id: '/cases/',
  path: '/cases/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAffectationIndexRoute =
  AuthenticatedAffectationIndexRouteImport.update({
    id: '/affectation/',
    path: '/affectation/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdversariesIndexRoute =
  AuthenticatedAdversariesIndexRouteImport.update({
    id: '/adversaries/',
    path: '/adversaries/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminLawyerProfilesIdRoute =
  AuthenticatedSuperAdminLawyerProfilesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedSuperAdminLawyerProfilesRoute,
  } as any)
const AuthenticatedSuperAdminDocumentTemplateSlugRoute =
  AuthenticatedSuperAdminDocumentTemplateSlugRouteImport.update({
    id: '/super-admin-document-template/$slug',
    path: '/super-admin-document-template/$slug',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCasesReportRoute =
  AuthenticatedCasesReportRouteImport.update({
    id: '/cases/report',
    path: '/cases/report',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCabinetDocumentTemplateSlugRoute =
  AuthenticatedCabinetDocumentTemplateSlugRouteImport.update({
    id: '/cabinet-document-template/$slug',
    path: '/cabinet-document-template/$slug',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersIdIndexLazyRoute =
  AuthenticatedUsersIdIndexLazyRouteImport.update({
    id: '/users/$id/',
    path: '/users/$id/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/users/$id/index.lazy').then((d) => d.Route),
  )
const AuthenticatedInvoicesIdIndexLazyRoute =
  AuthenticatedInvoicesIdIndexLazyRouteImport.update({
    id: '/invoices/$id/',
    path: '/invoices/$id/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/invoices/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedClientsIdIndexLazyRoute =
  AuthenticatedClientsIdIndexLazyRouteImport.update({
    id: '/clients/$id/',
    path: '/clients/$id/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/clients/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAdversariesIdIndexLazyRoute =
  AuthenticatedAdversariesIdIndexLazyRouteImport.update({
    id: '/adversaries/$id/',
    path: '/adversaries/$id/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/adversaries/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCasesIdIndexRoute =
  AuthenticatedCasesIdIndexRouteImport.update({
    id: '/cases/$id/',
    path: '/cases/$id/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/cases/$id/index.lazy').then((d) => d.Route),
  )
const AuthVerifyEmailConfirmUidb64TokenRoute =
  AuthVerifyEmailConfirmUidb64TokenRouteImport.update({
    id: '/auth/verify-email-confirm/$uidb64/$token',
    path: '/auth/verify-email-confirm/$uidb64/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthResetPasswordConfirmUidb64TokenRoute =
  AuthResetPasswordConfirmUidb64TokenRouteImport.update({
    id: '/auth/reset-password-confirm/$uidb64/$token',
    path: '/auth/reset-password-confirm/$uidb64/$token',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/auth/login': typeof AuthLoginRouteRoute
  '/auth/signup': typeof AuthSignupRouteRoute
  '/cabinet-billing': typeof AuthenticatedCabinetBillingRoute
  '/cabinet-document-template-create': typeof AuthenticatedCabinetDocumentTemplateCreateRoute
  '/cabinet-document-templates': typeof AuthenticatedCabinetDocumentTemplatesRoute
  '/cabinet-plans': typeof AuthenticatedCabinetPlansRoute
  '/cabinet-roles': typeof AuthenticatedCabinetRolesRoute
  '/cabinet-settings': typeof AuthenticatedCabinetSettingsRoute
  '/cabinet-subscriptions': typeof AuthenticatedCabinetSubscriptionsRoute
  '/chatbot': typeof AuthenticatedChatbotRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/documents': typeof AuthenticatedDocumentsRoute
  '/guides': typeof AuthenticatedGuidesRoute
  '/honoraires': typeof AuthenticatedHonorairesRoute
  '/lawyer-profile': typeof AuthenticatedLawyerProfileRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/super-admin-audit-logs': typeof AuthenticatedSuperAdminAuditLogsRoute
  '/super-admin-blog': typeof AuthenticatedSuperAdminBlogRoute
  '/super-admin-blog-create': typeof AuthenticatedSuperAdminBlogCreateRoute
  '/super-admin-blog-domains': typeof AuthenticatedSuperAdminBlogDomainsRoute
  '/super-admin-blog-edit': typeof AuthenticatedSuperAdminBlogEditRoute
  '/super-admin-blog-preview': typeof AuthenticatedSuperAdminBlogPreviewRoute
  '/super-admin-cabinets': typeof AuthenticatedSuperAdminCabinetsRoute
  '/super-admin-chatbot-config': typeof AuthenticatedSuperAdminChatbotConfigRoute
  '/super-admin-credit-management': typeof AuthenticatedSuperAdminCreditManagementRoute
  '/super-admin-crm': typeof AuthenticatedSuperAdminCrmRoute
  '/super-admin-dashboard': typeof AuthenticatedSuperAdminDashboardRoute
  '/super-admin-document-template-create': typeof AuthenticatedSuperAdminDocumentTemplateCreateRoute
  '/super-admin-document-templates': typeof AuthenticatedSuperAdminDocumentTemplatesRoute
  '/super-admin-feedback': typeof AuthenticatedSuperAdminFeedbackRoute
  '/super-admin-lawyer-profiles': typeof AuthenticatedSuperAdminLawyerProfilesRouteWithChildren
  '/super-admin-listing-requests': typeof AuthenticatedSuperAdminListingRequestsRoute
  '/super-admin-logs': typeof AuthenticatedSuperAdminLogsRoute
  '/super-admin-payments': typeof AuthenticatedSuperAdminPaymentsRoute
  '/super-admin-plans': typeof AuthenticatedSuperAdminPlansRoute
  '/super-admin-subscriptions': typeof AuthenticatedSuperAdminSubscriptionsRoute
  '/super-admin-template-requests': typeof AuthenticatedSuperAdminTemplateRequestsRoute
  '/super-admin-users': typeof AuthenticatedSuperAdminUsersRoute
  '/template-requests': typeof AuthenticatedTemplateRequestsRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/pending-approval': typeof AuthPendingApprovalRoute
  '/auth/reset-link-sent': typeof AuthResetLinkSentRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/': typeof AuthenticatedIndexRoute
  '/cabinet-document-template/$slug': typeof AuthenticatedCabinetDocumentTemplateSlugRoute
  '/cases/report': typeof AuthenticatedCasesReportRoute
  '/super-admin-document-template/$slug': typeof AuthenticatedSuperAdminDocumentTemplateSlugRoute
  '/super-admin-lawyer-profiles/$id': typeof AuthenticatedSuperAdminLawyerProfilesIdRoute
  '/adversaries': typeof AuthenticatedAdversariesIndexRoute
  '/affectation': typeof AuthenticatedAffectationIndexRoute
  '/cases': typeof AuthenticatedCasesIndexRoute
  '/clients': typeof AuthenticatedClientsIndexRoute
  '/expenses': typeof AuthenticatedExpensesIndexRoute
  '/external-lawyers': typeof AuthenticatedExternalLawyersIndexRoute
  '/invoices': typeof AuthenticatedInvoicesIndexRoute
  '/super-admin-lawyer-profiles/': typeof AuthenticatedSuperAdminLawyerProfilesIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/auth/reset-password-confirm/$uidb64/$token': typeof AuthResetPasswordConfirmUidb64TokenRoute
  '/auth/verify-email-confirm/$uidb64/$token': typeof AuthVerifyEmailConfirmUidb64TokenRoute
  '/cases/$id': typeof AuthenticatedCasesIdIndexRoute
  '/adversaries/$id': typeof AuthenticatedAdversariesIdIndexLazyRoute
  '/clients/$id': typeof AuthenticatedClientsIdIndexLazyRoute
  '/invoices/$id': typeof AuthenticatedInvoicesIdIndexLazyRoute
  '/users/$id': typeof AuthenticatedUsersIdIndexLazyRoute
}
export interface FileRoutesByTo {
  '/auth/login': typeof AuthLoginRouteRoute
  '/auth/signup': typeof AuthSignupRouteRoute
  '/cabinet-billing': typeof AuthenticatedCabinetBillingRoute
  '/cabinet-document-template-create': typeof AuthenticatedCabinetDocumentTemplateCreateRoute
  '/cabinet-document-templates': typeof AuthenticatedCabinetDocumentTemplatesRoute
  '/cabinet-plans': typeof AuthenticatedCabinetPlansRoute
  '/cabinet-roles': typeof AuthenticatedCabinetRolesRoute
  '/cabinet-settings': typeof AuthenticatedCabinetSettingsRoute
  '/cabinet-subscriptions': typeof AuthenticatedCabinetSubscriptionsRoute
  '/chatbot': typeof AuthenticatedChatbotRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/documents': typeof AuthenticatedDocumentsRoute
  '/guides': typeof AuthenticatedGuidesRoute
  '/honoraires': typeof AuthenticatedHonorairesRoute
  '/lawyer-profile': typeof AuthenticatedLawyerProfileRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/super-admin-audit-logs': typeof AuthenticatedSuperAdminAuditLogsRoute
  '/super-admin-blog': typeof AuthenticatedSuperAdminBlogRoute
  '/super-admin-blog-create': typeof AuthenticatedSuperAdminBlogCreateRoute
  '/super-admin-blog-domains': typeof AuthenticatedSuperAdminBlogDomainsRoute
  '/super-admin-blog-edit': typeof AuthenticatedSuperAdminBlogEditRoute
  '/super-admin-blog-preview': typeof AuthenticatedSuperAdminBlogPreviewRoute
  '/super-admin-cabinets': typeof AuthenticatedSuperAdminCabinetsRoute
  '/super-admin-chatbot-config': typeof AuthenticatedSuperAdminChatbotConfigRoute
  '/super-admin-credit-management': typeof AuthenticatedSuperAdminCreditManagementRoute
  '/super-admin-crm': typeof AuthenticatedSuperAdminCrmRoute
  '/super-admin-dashboard': typeof AuthenticatedSuperAdminDashboardRoute
  '/super-admin-document-template-create': typeof AuthenticatedSuperAdminDocumentTemplateCreateRoute
  '/super-admin-document-templates': typeof AuthenticatedSuperAdminDocumentTemplatesRoute
  '/super-admin-feedback': typeof AuthenticatedSuperAdminFeedbackRoute
  '/super-admin-listing-requests': typeof AuthenticatedSuperAdminListingRequestsRoute
  '/super-admin-logs': typeof AuthenticatedSuperAdminLogsRoute
  '/super-admin-payments': typeof AuthenticatedSuperAdminPaymentsRoute
  '/super-admin-plans': typeof AuthenticatedSuperAdminPlansRoute
  '/super-admin-subscriptions': typeof AuthenticatedSuperAdminSubscriptionsRoute
  '/super-admin-template-requests': typeof AuthenticatedSuperAdminTemplateRequestsRoute
  '/super-admin-users': typeof AuthenticatedSuperAdminUsersRoute
  '/template-requests': typeof AuthenticatedTemplateRequestsRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/pending-approval': typeof AuthPendingApprovalRoute
  '/auth/reset-link-sent': typeof AuthResetLinkSentRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/': typeof AuthenticatedIndexRoute
  '/cabinet-document-template/$slug': typeof AuthenticatedCabinetDocumentTemplateSlugRoute
  '/cases/report': typeof AuthenticatedCasesReportRoute
  '/super-admin-document-template/$slug': typeof AuthenticatedSuperAdminDocumentTemplateSlugRoute
  '/super-admin-lawyer-profiles/$id': typeof AuthenticatedSuperAdminLawyerProfilesIdRoute
  '/adversaries': typeof AuthenticatedAdversariesIndexRoute
  '/affectation': typeof AuthenticatedAffectationIndexRoute
  '/cases': typeof AuthenticatedCasesIndexRoute
  '/clients': typeof AuthenticatedClientsIndexRoute
  '/expenses': typeof AuthenticatedExpensesIndexRoute
  '/external-lawyers': typeof AuthenticatedExternalLawyersIndexRoute
  '/invoices': typeof AuthenticatedInvoicesIndexRoute
  '/super-admin-lawyer-profiles': typeof AuthenticatedSuperAdminLawyerProfilesIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/auth/reset-password-confirm/$uidb64/$token': typeof AuthResetPasswordConfirmUidb64TokenRoute
  '/auth/verify-email-confirm/$uidb64/$token': typeof AuthVerifyEmailConfirmUidb64TokenRoute
  '/cases/$id': typeof AuthenticatedCasesIdIndexRoute
  '/adversaries/$id': typeof AuthenticatedAdversariesIdIndexLazyRoute
  '/clients/$id': typeof AuthenticatedClientsIdIndexLazyRoute
  '/invoices/$id': typeof AuthenticatedInvoicesIdIndexLazyRoute
  '/users/$id': typeof AuthenticatedUsersIdIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRouteRoute
  '/auth/signup': typeof AuthSignupRouteRoute
  '/_authenticated/cabinet-billing': typeof AuthenticatedCabinetBillingRoute
  '/_authenticated/cabinet-document-template-create': typeof AuthenticatedCabinetDocumentTemplateCreateRoute
  '/_authenticated/cabinet-document-templates': typeof AuthenticatedCabinetDocumentTemplatesRoute
  '/_authenticated/cabinet-plans': typeof AuthenticatedCabinetPlansRoute
  '/_authenticated/cabinet-roles': typeof AuthenticatedCabinetRolesRoute
  '/_authenticated/cabinet-settings': typeof AuthenticatedCabinetSettingsRoute
  '/_authenticated/cabinet-subscriptions': typeof AuthenticatedCabinetSubscriptionsRoute
  '/_authenticated/chatbot': typeof AuthenticatedChatbotRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/documents': typeof AuthenticatedDocumentsRoute
  '/_authenticated/guides': typeof AuthenticatedGuidesRoute
  '/_authenticated/honoraires': typeof AuthenticatedHonorairesRoute
  '/_authenticated/lawyer-profile': typeof AuthenticatedLawyerProfileRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/super-admin-audit-logs': typeof AuthenticatedSuperAdminAuditLogsRoute
  '/_authenticated/super-admin-blog': typeof AuthenticatedSuperAdminBlogRoute
  '/_authenticated/super-admin-blog-create': typeof AuthenticatedSuperAdminBlogCreateRoute
  '/_authenticated/super-admin-blog-domains': typeof AuthenticatedSuperAdminBlogDomainsRoute
  '/_authenticated/super-admin-blog-edit': typeof AuthenticatedSuperAdminBlogEditRoute
  '/_authenticated/super-admin-blog-preview': typeof AuthenticatedSuperAdminBlogPreviewRoute
  '/_authenticated/super-admin-cabinets': typeof AuthenticatedSuperAdminCabinetsRoute
  '/_authenticated/super-admin-chatbot-config': typeof AuthenticatedSuperAdminChatbotConfigRoute
  '/_authenticated/super-admin-credit-management': typeof AuthenticatedSuperAdminCreditManagementRoute
  '/_authenticated/super-admin-crm': typeof AuthenticatedSuperAdminCrmRoute
  '/_authenticated/super-admin-dashboard': typeof AuthenticatedSuperAdminDashboardRoute
  '/_authenticated/super-admin-document-template-create': typeof AuthenticatedSuperAdminDocumentTemplateCreateRoute
  '/_authenticated/super-admin-document-templates': typeof AuthenticatedSuperAdminDocumentTemplatesRoute
  '/_authenticated/super-admin-feedback': typeof AuthenticatedSuperAdminFeedbackRoute
  '/_authenticated/super-admin-lawyer-profiles': typeof AuthenticatedSuperAdminLawyerProfilesRouteWithChildren
  '/_authenticated/super-admin-listing-requests': typeof AuthenticatedSuperAdminListingRequestsRoute
  '/_authenticated/super-admin-logs': typeof AuthenticatedSuperAdminLogsRoute
  '/_authenticated/super-admin-payments': typeof AuthenticatedSuperAdminPaymentsRoute
  '/_authenticated/super-admin-plans': typeof AuthenticatedSuperAdminPlansRoute
  '/_authenticated/super-admin-subscriptions': typeof AuthenticatedSuperAdminSubscriptionsRoute
  '/_authenticated/super-admin-template-requests': typeof AuthenticatedSuperAdminTemplateRequestsRoute
  '/_authenticated/super-admin-users': typeof AuthenticatedSuperAdminUsersRoute
  '/_authenticated/template-requests': typeof AuthenticatedTemplateRequestsRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/pending-approval': typeof AuthPendingApprovalRoute
  '/auth/reset-link-sent': typeof AuthResetLinkSentRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/cabinet-document-template/$slug': typeof AuthenticatedCabinetDocumentTemplateSlugRoute
  '/_authenticated/cases/report': typeof AuthenticatedCasesReportRoute
  '/_authenticated/super-admin-document-template/$slug': typeof AuthenticatedSuperAdminDocumentTemplateSlugRoute
  '/_authenticated/super-admin-lawyer-profiles/$id': typeof AuthenticatedSuperAdminLawyerProfilesIdRoute
  '/_authenticated/adversaries/': typeof AuthenticatedAdversariesIndexRoute
  '/_authenticated/affectation/': typeof AuthenticatedAffectationIndexRoute
  '/_authenticated/cases/': typeof AuthenticatedCasesIndexRoute
  '/_authenticated/clients/': typeof AuthenticatedClientsIndexRoute
  '/_authenticated/expenses/': typeof AuthenticatedExpensesIndexRoute
  '/_authenticated/external-lawyers/': typeof AuthenticatedExternalLawyersIndexRoute
  '/_authenticated/invoices/': typeof AuthenticatedInvoicesIndexRoute
  '/_authenticated/super-admin-lawyer-profiles/': typeof AuthenticatedSuperAdminLawyerProfilesIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/auth/reset-password-confirm/$uidb64/$token': typeof AuthResetPasswordConfirmUidb64TokenRoute
  '/auth/verify-email-confirm/$uidb64/$token': typeof AuthVerifyEmailConfirmUidb64TokenRoute
  '/_authenticated/cases/$id/': typeof AuthenticatedCasesIdIndexRoute
  '/_authenticated/adversaries/$id/': typeof AuthenticatedAdversariesIdIndexLazyRoute
  '/_authenticated/clients/$id/': typeof AuthenticatedClientsIdIndexLazyRoute
  '/_authenticated/invoices/$id/': typeof AuthenticatedInvoicesIdIndexLazyRoute
  '/_authenticated/users/$id/': typeof AuthenticatedUsersIdIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/auth/login'
    | '/auth/signup'
    | '/cabinet-billing'
    | '/cabinet-document-template-create'
    | '/cabinet-document-templates'
    | '/cabinet-plans'
    | '/cabinet-roles'
    | '/cabinet-settings'
    | '/cabinet-subscriptions'
    | '/chatbot'
    | '/dashboard'
    | '/documents'
    | '/guides'
    | '/honoraires'
    | '/lawyer-profile'
    | '/profile'
    | '/super-admin-audit-logs'
    | '/super-admin-blog'
    | '/super-admin-blog-create'
    | '/super-admin-blog-domains'
    | '/super-admin-blog-edit'
    | '/super-admin-blog-preview'
    | '/super-admin-cabinets'
    | '/super-admin-chatbot-config'
    | '/super-admin-credit-management'
    | '/super-admin-crm'
    | '/super-admin-dashboard'
    | '/super-admin-document-template-create'
    | '/super-admin-document-templates'
    | '/super-admin-feedback'
    | '/super-admin-lawyer-profiles'
    | '/super-admin-listing-requests'
    | '/super-admin-logs'
    | '/super-admin-payments'
    | '/super-admin-plans'
    | '/super-admin-subscriptions'
    | '/super-admin-template-requests'
    | '/super-admin-users'
    | '/template-requests'
    | '/auth/forgot-password'
    | '/auth/pending-approval'
    | '/auth/reset-link-sent'
    | '/auth/verify-email'
    | '/'
    | '/cabinet-document-template/$slug'
    | '/cases/report'
    | '/super-admin-document-template/$slug'
    | '/super-admin-lawyer-profiles/$id'
    | '/adversaries'
    | '/affectation'
    | '/cases'
    | '/clients'
    | '/expenses'
    | '/external-lawyers'
    | '/invoices'
    | '/super-admin-lawyer-profiles/'
    | '/users'
    | '/auth/reset-password-confirm/$uidb64/$token'
    | '/auth/verify-email-confirm/$uidb64/$token'
    | '/cases/$id'
    | '/adversaries/$id'
    | '/clients/$id'
    | '/invoices/$id'
    | '/users/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth/login'
    | '/auth/signup'
    | '/cabinet-billing'
    | '/cabinet-document-template-create'
    | '/cabinet-document-templates'
    | '/cabinet-plans'
    | '/cabinet-roles'
    | '/cabinet-settings'
    | '/cabinet-subscriptions'
    | '/chatbot'
    | '/dashboard'
    | '/documents'
    | '/guides'
    | '/honoraires'
    | '/lawyer-profile'
    | '/profile'
    | '/super-admin-audit-logs'
    | '/super-admin-blog'
    | '/super-admin-blog-create'
    | '/super-admin-blog-domains'
    | '/super-admin-blog-edit'
    | '/super-admin-blog-preview'
    | '/super-admin-cabinets'
    | '/super-admin-chatbot-config'
    | '/super-admin-credit-management'
    | '/super-admin-crm'
    | '/super-admin-dashboard'
    | '/super-admin-document-template-create'
    | '/super-admin-document-templates'
    | '/super-admin-feedback'
    | '/super-admin-listing-requests'
    | '/super-admin-logs'
    | '/super-admin-payments'
    | '/super-admin-plans'
    | '/super-admin-subscriptions'
    | '/super-admin-template-requests'
    | '/super-admin-users'
    | '/template-requests'
    | '/auth/forgot-password'
    | '/auth/pending-approval'
    | '/auth/reset-link-sent'
    | '/auth/verify-email'
    | '/'
    | '/cabinet-document-template/$slug'
    | '/cases/report'
    | '/super-admin-document-template/$slug'
    | '/super-admin-lawyer-profiles/$id'
    | '/adversaries'
    | '/affectation'
    | '/cases'
    | '/clients'
    | '/expenses'
    | '/external-lawyers'
    | '/invoices'
    | '/super-admin-lawyer-profiles'
    | '/users'
    | '/auth/reset-password-confirm/$uidb64/$token'
    | '/auth/verify-email-confirm/$uidb64/$token'
    | '/cases/$id'
    | '/adversaries/$id'
    | '/clients/$id'
    | '/invoices/$id'
    | '/users/$id'
  id:
    | '__root__'
    | '/_authenticated'
    | '/auth/login'
    | '/auth/signup'
    | '/_authenticated/cabinet-billing'
    | '/_authenticated/cabinet-document-template-create'
    | '/_authenticated/cabinet-document-templates'
    | '/_authenticated/cabinet-plans'
    | '/_authenticated/cabinet-roles'
    | '/_authenticated/cabinet-settings'
    | '/_authenticated/cabinet-subscriptions'
    | '/_authenticated/chatbot'
    | '/_authenticated/dashboard'
    | '/_authenticated/documents'
    | '/_authenticated/guides'
    | '/_authenticated/honoraires'
    | '/_authenticated/lawyer-profile'
    | '/_authenticated/profile'
    | '/_authenticated/super-admin-audit-logs'
    | '/_authenticated/super-admin-blog'
    | '/_authenticated/super-admin-blog-create'
    | '/_authenticated/super-admin-blog-domains'
    | '/_authenticated/super-admin-blog-edit'
    | '/_authenticated/super-admin-blog-preview'
    | '/_authenticated/super-admin-cabinets'
    | '/_authenticated/super-admin-chatbot-config'
    | '/_authenticated/super-admin-credit-management'
    | '/_authenticated/super-admin-crm'
    | '/_authenticated/super-admin-dashboard'
    | '/_authenticated/super-admin-document-template-create'
    | '/_authenticated/super-admin-document-templates'
    | '/_authenticated/super-admin-feedback'
    | '/_authenticated/super-admin-lawyer-profiles'
    | '/_authenticated/super-admin-listing-requests'
    | '/_authenticated/super-admin-logs'
    | '/_authenticated/super-admin-payments'
    | '/_authenticated/super-admin-plans'
    | '/_authenticated/super-admin-subscriptions'
    | '/_authenticated/super-admin-template-requests'
    | '/_authenticated/super-admin-users'
    | '/_authenticated/template-requests'
    | '/auth/forgot-password'
    | '/auth/pending-approval'
    | '/auth/reset-link-sent'
    | '/auth/verify-email'
    | '/_authenticated/'
    | '/_authenticated/cabinet-document-template/$slug'
    | '/_authenticated/cases/report'
    | '/_authenticated/super-admin-document-template/$slug'
    | '/_authenticated/super-admin-lawyer-profiles/$id'
    | '/_authenticated/adversaries/'
    | '/_authenticated/affectation/'
    | '/_authenticated/cases/'
    | '/_authenticated/clients/'
    | '/_authenticated/expenses/'
    | '/_authenticated/external-lawyers/'
    | '/_authenticated/invoices/'
    | '/_authenticated/super-admin-lawyer-profiles/'
    | '/_authenticated/users/'
    | '/auth/reset-password-confirm/$uidb64/$token'
    | '/auth/verify-email-confirm/$uidb64/$token'
    | '/_authenticated/cases/$id/'
    | '/_authenticated/adversaries/$id/'
    | '/_authenticated/clients/$id/'
    | '/_authenticated/invoices/$id/'
    | '/_authenticated/users/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  AuthLoginRouteRoute: typeof AuthLoginRouteRoute
  AuthSignupRouteRoute: typeof AuthSignupRouteRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthPendingApprovalRoute: typeof AuthPendingApprovalRoute
  AuthResetLinkSentRoute: typeof AuthResetLinkSentRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
  AuthResetPasswordConfirmUidb64TokenRoute: typeof AuthResetPasswordConfirmUidb64TokenRoute
  AuthVerifyEmailConfirmUidb64TokenRoute: typeof AuthVerifyEmailConfirmUidb64TokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/auth/verify-email': {
      id: '/auth/verify-email'
      path: '/auth/verify-email'
      fullPath: '/auth/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-link-sent': {
      id: '/auth/reset-link-sent'
      path: '/auth/reset-link-sent'
      fullPath: '/auth/reset-link-sent'
      preLoaderRoute: typeof AuthResetLinkSentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/pending-approval': {
      id: '/auth/pending-approval'
      path: '/auth/pending-approval'
      fullPath: '/auth/pending-approval'
      preLoaderRoute: typeof AuthPendingApprovalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/template-requests': {
      id: '/_authenticated/template-requests'
      path: '/template-requests'
      fullPath: '/template-requests'
      preLoaderRoute: typeof AuthenticatedTemplateRequestsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-users': {
      id: '/_authenticated/super-admin-users'
      path: '/super-admin-users'
      fullPath: '/super-admin-users'
      preLoaderRoute: typeof AuthenticatedSuperAdminUsersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-template-requests': {
      id: '/_authenticated/super-admin-template-requests'
      path: '/super-admin-template-requests'
      fullPath: '/super-admin-template-requests'
      preLoaderRoute: typeof AuthenticatedSuperAdminTemplateRequestsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-subscriptions': {
      id: '/_authenticated/super-admin-subscriptions'
      path: '/super-admin-subscriptions'
      fullPath: '/super-admin-subscriptions'
      preLoaderRoute: typeof AuthenticatedSuperAdminSubscriptionsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-plans': {
      id: '/_authenticated/super-admin-plans'
      path: '/super-admin-plans'
      fullPath: '/super-admin-plans'
      preLoaderRoute: typeof AuthenticatedSuperAdminPlansRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-payments': {
      id: '/_authenticated/super-admin-payments'
      path: '/super-admin-payments'
      fullPath: '/super-admin-payments'
      preLoaderRoute: typeof AuthenticatedSuperAdminPaymentsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-logs': {
      id: '/_authenticated/super-admin-logs'
      path: '/super-admin-logs'
      fullPath: '/super-admin-logs'
      preLoaderRoute: typeof AuthenticatedSuperAdminLogsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-listing-requests': {
      id: '/_authenticated/super-admin-listing-requests'
      path: '/super-admin-listing-requests'
      fullPath: '/super-admin-listing-requests'
      preLoaderRoute: typeof AuthenticatedSuperAdminListingRequestsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-lawyer-profiles': {
      id: '/_authenticated/super-admin-lawyer-profiles'
      path: '/super-admin-lawyer-profiles'
      fullPath: '/super-admin-lawyer-profiles'
      preLoaderRoute: typeof AuthenticatedSuperAdminLawyerProfilesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-feedback': {
      id: '/_authenticated/super-admin-feedback'
      path: '/super-admin-feedback'
      fullPath: '/super-admin-feedback'
      preLoaderRoute: typeof AuthenticatedSuperAdminFeedbackRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-document-templates': {
      id: '/_authenticated/super-admin-document-templates'
      path: '/super-admin-document-templates'
      fullPath: '/super-admin-document-templates'
      preLoaderRoute: typeof AuthenticatedSuperAdminDocumentTemplatesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-document-template-create': {
      id: '/_authenticated/super-admin-document-template-create'
      path: '/super-admin-document-template-create'
      fullPath: '/super-admin-document-template-create'
      preLoaderRoute: typeof AuthenticatedSuperAdminDocumentTemplateCreateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-dashboard': {
      id: '/_authenticated/super-admin-dashboard'
      path: '/super-admin-dashboard'
      fullPath: '/super-admin-dashboard'
      preLoaderRoute: typeof AuthenticatedSuperAdminDashboardRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-crm': {
      id: '/_authenticated/super-admin-crm'
      path: '/super-admin-crm'
      fullPath: '/super-admin-crm'
      preLoaderRoute: typeof AuthenticatedSuperAdminCrmRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-credit-management': {
      id: '/_authenticated/super-admin-credit-management'
      path: '/super-admin-credit-management'
      fullPath: '/super-admin-credit-management'
      preLoaderRoute: typeof AuthenticatedSuperAdminCreditManagementRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-chatbot-config': {
      id: '/_authenticated/super-admin-chatbot-config'
      path: '/super-admin-chatbot-config'
      fullPath: '/super-admin-chatbot-config'
      preLoaderRoute: typeof AuthenticatedSuperAdminChatbotConfigRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-cabinets': {
      id: '/_authenticated/super-admin-cabinets'
      path: '/super-admin-cabinets'
      fullPath: '/super-admin-cabinets'
      preLoaderRoute: typeof AuthenticatedSuperAdminCabinetsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-blog-preview': {
      id: '/_authenticated/super-admin-blog-preview'
      path: '/super-admin-blog-preview'
      fullPath: '/super-admin-blog-preview'
      preLoaderRoute: typeof AuthenticatedSuperAdminBlogPreviewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-blog-edit': {
      id: '/_authenticated/super-admin-blog-edit'
      path: '/super-admin-blog-edit'
      fullPath: '/super-admin-blog-edit'
      preLoaderRoute: typeof AuthenticatedSuperAdminBlogEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-blog-domains': {
      id: '/_authenticated/super-admin-blog-domains'
      path: '/super-admin-blog-domains'
      fullPath: '/super-admin-blog-domains'
      preLoaderRoute: typeof AuthenticatedSuperAdminBlogDomainsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-blog-create': {
      id: '/_authenticated/super-admin-blog-create'
      path: '/super-admin-blog-create'
      fullPath: '/super-admin-blog-create'
      preLoaderRoute: typeof AuthenticatedSuperAdminBlogCreateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-blog': {
      id: '/_authenticated/super-admin-blog'
      path: '/super-admin-blog'
      fullPath: '/super-admin-blog'
      preLoaderRoute: typeof AuthenticatedSuperAdminBlogRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-audit-logs': {
      id: '/_authenticated/super-admin-audit-logs'
      path: '/super-admin-audit-logs'
      fullPath: '/super-admin-audit-logs'
      preLoaderRoute: typeof AuthenticatedSuperAdminAuditLogsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/lawyer-profile': {
      id: '/_authenticated/lawyer-profile'
      path: '/lawyer-profile'
      fullPath: '/lawyer-profile'
      preLoaderRoute: typeof AuthenticatedLawyerProfileRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/honoraires': {
      id: '/_authenticated/honoraires'
      path: '/honoraires'
      fullPath: '/honoraires'
      preLoaderRoute: typeof AuthenticatedHonorairesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/guides': {
      id: '/_authenticated/guides'
      path: '/guides'
      fullPath: '/guides'
      preLoaderRoute: typeof AuthenticatedGuidesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/documents': {
      id: '/_authenticated/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AuthenticatedDocumentsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chatbot': {
      id: '/_authenticated/chatbot'
      path: '/chatbot'
      fullPath: '/chatbot'
      preLoaderRoute: typeof AuthenticatedChatbotRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cabinet-subscriptions': {
      id: '/_authenticated/cabinet-subscriptions'
      path: '/cabinet-subscriptions'
      fullPath: '/cabinet-subscriptions'
      preLoaderRoute: typeof AuthenticatedCabinetSubscriptionsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cabinet-settings': {
      id: '/_authenticated/cabinet-settings'
      path: '/cabinet-settings'
      fullPath: '/cabinet-settings'
      preLoaderRoute: typeof AuthenticatedCabinetSettingsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cabinet-roles': {
      id: '/_authenticated/cabinet-roles'
      path: '/cabinet-roles'
      fullPath: '/cabinet-roles'
      preLoaderRoute: typeof AuthenticatedCabinetRolesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cabinet-plans': {
      id: '/_authenticated/cabinet-plans'
      path: '/cabinet-plans'
      fullPath: '/cabinet-plans'
      preLoaderRoute: typeof AuthenticatedCabinetPlansRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cabinet-document-templates': {
      id: '/_authenticated/cabinet-document-templates'
      path: '/cabinet-document-templates'
      fullPath: '/cabinet-document-templates'
      preLoaderRoute: typeof AuthenticatedCabinetDocumentTemplatesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cabinet-document-template-create': {
      id: '/_authenticated/cabinet-document-template-create'
      path: '/cabinet-document-template-create'
      fullPath: '/cabinet-document-template-create'
      preLoaderRoute: typeof AuthenticatedCabinetDocumentTemplateCreateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cabinet-billing': {
      id: '/_authenticated/cabinet-billing'
      path: '/cabinet-billing'
      fullPath: '/cabinet-billing'
      preLoaderRoute: typeof AuthenticatedCabinetBillingRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/auth/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-lawyer-profiles/': {
      id: '/_authenticated/super-admin-lawyer-profiles/'
      path: '/'
      fullPath: '/super-admin-lawyer-profiles/'
      preLoaderRoute: typeof AuthenticatedSuperAdminLawyerProfilesIndexRouteImport
      parentRoute: typeof AuthenticatedSuperAdminLawyerProfilesRoute
    }
    '/_authenticated/invoices/': {
      id: '/_authenticated/invoices/'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof AuthenticatedInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/external-lawyers/': {
      id: '/_authenticated/external-lawyers/'
      path: '/external-lawyers'
      fullPath: '/external-lawyers'
      preLoaderRoute: typeof AuthenticatedExternalLawyersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/expenses/': {
      id: '/_authenticated/expenses/'
      path: '/expenses'
      fullPath: '/expenses'
      preLoaderRoute: typeof AuthenticatedExpensesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/clients/': {
      id: '/_authenticated/clients/'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AuthenticatedClientsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cases/': {
      id: '/_authenticated/cases/'
      path: '/cases'
      fullPath: '/cases'
      preLoaderRoute: typeof AuthenticatedCasesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/affectation/': {
      id: '/_authenticated/affectation/'
      path: '/affectation'
      fullPath: '/affectation'
      preLoaderRoute: typeof AuthenticatedAffectationIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/adversaries/': {
      id: '/_authenticated/adversaries/'
      path: '/adversaries'
      fullPath: '/adversaries'
      preLoaderRoute: typeof AuthenticatedAdversariesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin-lawyer-profiles/$id': {
      id: '/_authenticated/super-admin-lawyer-profiles/$id'
      path: '/$id'
      fullPath: '/super-admin-lawyer-profiles/$id'
      preLoaderRoute: typeof AuthenticatedSuperAdminLawyerProfilesIdRouteImport
      parentRoute: typeof AuthenticatedSuperAdminLawyerProfilesRoute
    }
    '/_authenticated/super-admin-document-template/$slug': {
      id: '/_authenticated/super-admin-document-template/$slug'
      path: '/super-admin-document-template/$slug'
      fullPath: '/super-admin-document-template/$slug'
      preLoaderRoute: typeof AuthenticatedSuperAdminDocumentTemplateSlugRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cases/report': {
      id: '/_authenticated/cases/report'
      path: '/cases/report'
      fullPath: '/cases/report'
      preLoaderRoute: typeof AuthenticatedCasesReportRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cabinet-document-template/$slug': {
      id: '/_authenticated/cabinet-document-template/$slug'
      path: '/cabinet-document-template/$slug'
      fullPath: '/cabinet-document-template/$slug'
      preLoaderRoute: typeof AuthenticatedCabinetDocumentTemplateSlugRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/$id/': {
      id: '/_authenticated/users/$id/'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AuthenticatedUsersIdIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/invoices/$id/': {
      id: '/_authenticated/invoices/$id/'
      path: '/invoices/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof AuthenticatedInvoicesIdIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/clients/$id/': {
      id: '/_authenticated/clients/$id/'
      path: '/clients/$id'
      fullPath: '/clients/$id'
      preLoaderRoute: typeof AuthenticatedClientsIdIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/adversaries/$id/': {
      id: '/_authenticated/adversaries/$id/'
      path: '/adversaries/$id'
      fullPath: '/adversaries/$id'
      preLoaderRoute: typeof AuthenticatedAdversariesIdIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cases/$id/': {
      id: '/_authenticated/cases/$id/'
      path: '/cases/$id'
      fullPath: '/cases/$id'
      preLoaderRoute: typeof AuthenticatedCasesIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/auth/verify-email-confirm/$uidb64/$token': {
      id: '/auth/verify-email-confirm/$uidb64/$token'
      path: '/auth/verify-email-confirm/$uidb64/$token'
      fullPath: '/auth/verify-email-confirm/$uidb64/$token'
      preLoaderRoute: typeof AuthVerifyEmailConfirmUidb64TokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password-confirm/$uidb64/$token': {
      id: '/auth/reset-password-confirm/$uidb64/$token'
      path: '/auth/reset-password-confirm/$uidb64/$token'
      fullPath: '/auth/reset-password-confirm/$uidb64/$token'
      preLoaderRoute: typeof AuthResetPasswordConfirmUidb64TokenRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AuthenticatedSuperAdminLawyerProfilesRouteChildren {
  AuthenticatedSuperAdminLawyerProfilesIdRoute: typeof AuthenticatedSuperAdminLawyerProfilesIdRoute
  AuthenticatedSuperAdminLawyerProfilesIndexRoute: typeof AuthenticatedSuperAdminLawyerProfilesIndexRoute
}

const AuthenticatedSuperAdminLawyerProfilesRouteChildren: AuthenticatedSuperAdminLawyerProfilesRouteChildren =
  {
    AuthenticatedSuperAdminLawyerProfilesIdRoute:
      AuthenticatedSuperAdminLawyerProfilesIdRoute,
    AuthenticatedSuperAdminLawyerProfilesIndexRoute:
      AuthenticatedSuperAdminLawyerProfilesIndexRoute,
  }

const AuthenticatedSuperAdminLawyerProfilesRouteWithChildren =
  AuthenticatedSuperAdminLawyerProfilesRoute._addFileChildren(
    AuthenticatedSuperAdminLawyerProfilesRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedCabinetBillingRoute: typeof AuthenticatedCabinetBillingRoute
  AuthenticatedCabinetDocumentTemplateCreateRoute: typeof AuthenticatedCabinetDocumentTemplateCreateRoute
  AuthenticatedCabinetDocumentTemplatesRoute: typeof AuthenticatedCabinetDocumentTemplatesRoute
  AuthenticatedCabinetPlansRoute: typeof AuthenticatedCabinetPlansRoute
  AuthenticatedCabinetRolesRoute: typeof AuthenticatedCabinetRolesRoute
  AuthenticatedCabinetSettingsRoute: typeof AuthenticatedCabinetSettingsRoute
  AuthenticatedCabinetSubscriptionsRoute: typeof AuthenticatedCabinetSubscriptionsRoute
  AuthenticatedChatbotRoute: typeof AuthenticatedChatbotRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedDocumentsRoute: typeof AuthenticatedDocumentsRoute
  AuthenticatedGuidesRoute: typeof AuthenticatedGuidesRoute
  AuthenticatedHonorairesRoute: typeof AuthenticatedHonorairesRoute
  AuthenticatedLawyerProfileRoute: typeof AuthenticatedLawyerProfileRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedSuperAdminAuditLogsRoute: typeof AuthenticatedSuperAdminAuditLogsRoute
  AuthenticatedSuperAdminBlogRoute: typeof AuthenticatedSuperAdminBlogRoute
  AuthenticatedSuperAdminBlogCreateRoute: typeof AuthenticatedSuperAdminBlogCreateRoute
  AuthenticatedSuperAdminBlogDomainsRoute: typeof AuthenticatedSuperAdminBlogDomainsRoute
  AuthenticatedSuperAdminBlogEditRoute: typeof AuthenticatedSuperAdminBlogEditRoute
  AuthenticatedSuperAdminBlogPreviewRoute: typeof AuthenticatedSuperAdminBlogPreviewRoute
  AuthenticatedSuperAdminCabinetsRoute: typeof AuthenticatedSuperAdminCabinetsRoute
  AuthenticatedSuperAdminChatbotConfigRoute: typeof AuthenticatedSuperAdminChatbotConfigRoute
  AuthenticatedSuperAdminCreditManagementRoute: typeof AuthenticatedSuperAdminCreditManagementRoute
  AuthenticatedSuperAdminCrmRoute: typeof AuthenticatedSuperAdminCrmRoute
  AuthenticatedSuperAdminDashboardRoute: typeof AuthenticatedSuperAdminDashboardRoute
  AuthenticatedSuperAdminDocumentTemplateCreateRoute: typeof AuthenticatedSuperAdminDocumentTemplateCreateRoute
  AuthenticatedSuperAdminDocumentTemplatesRoute: typeof AuthenticatedSuperAdminDocumentTemplatesRoute
  AuthenticatedSuperAdminFeedbackRoute: typeof AuthenticatedSuperAdminFeedbackRoute
  AuthenticatedSuperAdminLawyerProfilesRoute: typeof AuthenticatedSuperAdminLawyerProfilesRouteWithChildren
  AuthenticatedSuperAdminListingRequestsRoute: typeof AuthenticatedSuperAdminListingRequestsRoute
  AuthenticatedSuperAdminLogsRoute: typeof AuthenticatedSuperAdminLogsRoute
  AuthenticatedSuperAdminPaymentsRoute: typeof AuthenticatedSuperAdminPaymentsRoute
  AuthenticatedSuperAdminPlansRoute: typeof AuthenticatedSuperAdminPlansRoute
  AuthenticatedSuperAdminSubscriptionsRoute: typeof AuthenticatedSuperAdminSubscriptionsRoute
  AuthenticatedSuperAdminTemplateRequestsRoute: typeof AuthenticatedSuperAdminTemplateRequestsRoute
  AuthenticatedSuperAdminUsersRoute: typeof AuthenticatedSuperAdminUsersRoute
  AuthenticatedTemplateRequestsRoute: typeof AuthenticatedTemplateRequestsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedCabinetDocumentTemplateSlugRoute: typeof AuthenticatedCabinetDocumentTemplateSlugRoute
  AuthenticatedCasesReportRoute: typeof AuthenticatedCasesReportRoute
  AuthenticatedSuperAdminDocumentTemplateSlugRoute: typeof AuthenticatedSuperAdminDocumentTemplateSlugRoute
  AuthenticatedAdversariesIndexRoute: typeof AuthenticatedAdversariesIndexRoute
  AuthenticatedAffectationIndexRoute: typeof AuthenticatedAffectationIndexRoute
  AuthenticatedCasesIndexRoute: typeof AuthenticatedCasesIndexRoute
  AuthenticatedClientsIndexRoute: typeof AuthenticatedClientsIndexRoute
  AuthenticatedExpensesIndexRoute: typeof AuthenticatedExpensesIndexRoute
  AuthenticatedExternalLawyersIndexRoute: typeof AuthenticatedExternalLawyersIndexRoute
  AuthenticatedInvoicesIndexRoute: typeof AuthenticatedInvoicesIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedCasesIdIndexRoute: typeof AuthenticatedCasesIdIndexRoute
  AuthenticatedAdversariesIdIndexLazyRoute: typeof AuthenticatedAdversariesIdIndexLazyRoute
  AuthenticatedClientsIdIndexLazyRoute: typeof AuthenticatedClientsIdIndexLazyRoute
  AuthenticatedInvoicesIdIndexLazyRoute: typeof AuthenticatedInvoicesIdIndexLazyRoute
  AuthenticatedUsersIdIndexLazyRoute: typeof AuthenticatedUsersIdIndexLazyRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedCabinetBillingRoute: AuthenticatedCabinetBillingRoute,
  AuthenticatedCabinetDocumentTemplateCreateRoute:
    AuthenticatedCabinetDocumentTemplateCreateRoute,
  AuthenticatedCabinetDocumentTemplatesRoute:
    AuthenticatedCabinetDocumentTemplatesRoute,
  AuthenticatedCabinetPlansRoute: AuthenticatedCabinetPlansRoute,
  AuthenticatedCabinetRolesRoute: AuthenticatedCabinetRolesRoute,
  AuthenticatedCabinetSettingsRoute: AuthenticatedCabinetSettingsRoute,
  AuthenticatedCabinetSubscriptionsRoute:
    AuthenticatedCabinetSubscriptionsRoute,
  AuthenticatedChatbotRoute: AuthenticatedChatbotRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedDocumentsRoute: AuthenticatedDocumentsRoute,
  AuthenticatedGuidesRoute: AuthenticatedGuidesRoute,
  AuthenticatedHonorairesRoute: AuthenticatedHonorairesRoute,
  AuthenticatedLawyerProfileRoute: AuthenticatedLawyerProfileRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedSuperAdminAuditLogsRoute: AuthenticatedSuperAdminAuditLogsRoute,
  AuthenticatedSuperAdminBlogRoute: AuthenticatedSuperAdminBlogRoute,
  AuthenticatedSuperAdminBlogCreateRoute:
    AuthenticatedSuperAdminBlogCreateRoute,
  AuthenticatedSuperAdminBlogDomainsRoute:
    AuthenticatedSuperAdminBlogDomainsRoute,
  AuthenticatedSuperAdminBlogEditRoute: AuthenticatedSuperAdminBlogEditRoute,
  AuthenticatedSuperAdminBlogPreviewRoute:
    AuthenticatedSuperAdminBlogPreviewRoute,
  AuthenticatedSuperAdminCabinetsRoute: AuthenticatedSuperAdminCabinetsRoute,
  AuthenticatedSuperAdminChatbotConfigRoute:
    AuthenticatedSuperAdminChatbotConfigRoute,
  AuthenticatedSuperAdminCreditManagementRoute:
    AuthenticatedSuperAdminCreditManagementRoute,
  AuthenticatedSuperAdminCrmRoute: AuthenticatedSuperAdminCrmRoute,
  AuthenticatedSuperAdminDashboardRoute: AuthenticatedSuperAdminDashboardRoute,
  AuthenticatedSuperAdminDocumentTemplateCreateRoute:
    AuthenticatedSuperAdminDocumentTemplateCreateRoute,
  AuthenticatedSuperAdminDocumentTemplatesRoute:
    AuthenticatedSuperAdminDocumentTemplatesRoute,
  AuthenticatedSuperAdminFeedbackRoute: AuthenticatedSuperAdminFeedbackRoute,
  AuthenticatedSuperAdminLawyerProfilesRoute:
    AuthenticatedSuperAdminLawyerProfilesRouteWithChildren,
  AuthenticatedSuperAdminListingRequestsRoute:
    AuthenticatedSuperAdminListingRequestsRoute,
  AuthenticatedSuperAdminLogsRoute: AuthenticatedSuperAdminLogsRoute,
  AuthenticatedSuperAdminPaymentsRoute: AuthenticatedSuperAdminPaymentsRoute,
  AuthenticatedSuperAdminPlansRoute: AuthenticatedSuperAdminPlansRoute,
  AuthenticatedSuperAdminSubscriptionsRoute:
    AuthenticatedSuperAdminSubscriptionsRoute,
  AuthenticatedSuperAdminTemplateRequestsRoute:
    AuthenticatedSuperAdminTemplateRequestsRoute,
  AuthenticatedSuperAdminUsersRoute: AuthenticatedSuperAdminUsersRoute,
  AuthenticatedTemplateRequestsRoute: AuthenticatedTemplateRequestsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedCabinetDocumentTemplateSlugRoute:
    AuthenticatedCabinetDocumentTemplateSlugRoute,
  AuthenticatedCasesReportRoute: AuthenticatedCasesReportRoute,
  AuthenticatedSuperAdminDocumentTemplateSlugRoute:
    AuthenticatedSuperAdminDocumentTemplateSlugRoute,
  AuthenticatedAdversariesIndexRoute: AuthenticatedAdversariesIndexRoute,
  AuthenticatedAffectationIndexRoute: AuthenticatedAffectationIndexRoute,
  AuthenticatedCasesIndexRoute: AuthenticatedCasesIndexRoute,
  AuthenticatedClientsIndexRoute: AuthenticatedClientsIndexRoute,
  AuthenticatedExpensesIndexRoute: AuthenticatedExpensesIndexRoute,
  AuthenticatedExternalLawyersIndexRoute:
    AuthenticatedExternalLawyersIndexRoute,
  AuthenticatedInvoicesIndexRoute: AuthenticatedInvoicesIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedCasesIdIndexRoute: AuthenticatedCasesIdIndexRoute,
  AuthenticatedAdversariesIdIndexLazyRoute:
    AuthenticatedAdversariesIdIndexLazyRoute,
  AuthenticatedClientsIdIndexLazyRoute: AuthenticatedClientsIdIndexLazyRoute,
  AuthenticatedInvoicesIdIndexLazyRoute: AuthenticatedInvoicesIdIndexLazyRoute,
  AuthenticatedUsersIdIndexLazyRoute: AuthenticatedUsersIdIndexLazyRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  AuthLoginRouteRoute: AuthLoginRouteRoute,
  AuthSignupRouteRoute: AuthSignupRouteRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthPendingApprovalRoute: AuthPendingApprovalRoute,
  AuthResetLinkSentRoute: AuthResetLinkSentRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
  AuthResetPasswordConfirmUidb64TokenRoute:
    AuthResetPasswordConfirmUidb64TokenRoute,
  AuthVerifyEmailConfirmUidb64TokenRoute:
    AuthVerifyEmailConfirmUidb64TokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
